// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import "../assets/Loan/ViewLoanCollectionReceipt.css"; // Create this file
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// const ViewLoanCollectionReceipt = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const receiptRef = useRef(null);
//   const thermalReceiptRef=useRef(null)
//   const data = location.state?.collectionReceipt;
//   console.log("cusotmer", data);

//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();
//   console.log("profile", profile);

//   const [company, setCompany] = useState(null);

//   // fetch profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   const fetchCompany = async () => {
//     try {
//       const res = await fetch(
//         `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
//       );
//       const data = await res.json();
//       if (res.ok && data) {
//         if (data.logo) {
//           data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//         }
//         if (data.qrCodeImage) {
//           data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
//         }
//         setCompany(data);
//       }
//     } catch (err) {
//       console.error("Error fetching company:", err);
//     }
//   };

//   useEffect(() => {
//     fetchCompany();
//   }, [profile?.superAdminId]);

//   const handlePrint = async () => {
//     if (!receiptRef.current) return;

//     const canvas = await html2canvas(receiptRef.current, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#fff",
//     });

//     const imgData = canvas.toDataURL("image/jpeg", 0.8);
//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: "a4", // Professional receipts usually A4 or A5
//     });

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

//     pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

//     // Stable Print logic
//     const blobUrl = pdf.output("bloburl");
//     const iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     iframe.src = blobUrl;
//     document.body.appendChild(iframe);

//     iframe.onload = () => {
//       iframe.contentWindow.focus();
//       iframe.contentWindow.print();
//       window.addEventListener(
//         "focus",
//         () => {
//           setTimeout(() => {
//             if (document.body.contains(iframe))
//               document.body.removeChild(iframe);
//           }, 500);
//         },
//         { once: true },
//       );
//     };
//   };


//    const handlePrintThermalSlip = async () => {
//     if (!thermalReceiptRef.current) return;

//     const { jsPDF } = await import("jspdf");
//     const html2canvas = (await import("html2canvas")).default;

//     // 1️⃣ Render slip to canvas
//     const canvas = await html2canvas(thermalReceiptRef.current, {
//       scale: 3,
//       backgroundColor: "#ffffff",
//     });
//     const imgData = canvas.toDataURL("image/png");

//     // 2️⃣ Prepare PDF (thermal size)
//     const pdfWidth = 58; // mm
//     const imgWidth = pdfWidth;
//     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: [pdfWidth, imgHeight],
//     });
//     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

//     // 3️⃣ Try to open print window
//     try {
//       const printWindow = window.open("", "_blank", "width=1000,height=600");

//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Print Slip</title>
//             <style>
//               @page { size: 58mm auto; margin:0; }
//               body { margin:0; padding:0; text-align:center; }
//               img { width:58mm; max-width:58mm; }
//             </style>
//           </head>
//           <body>
//             <img src="${imgData}" />
//           </body>
//         </html>
//       `);

//       printWindow.document.close();

//       // Wait for print window to load
//       printWindow.onload = () => {
//         printWindow.focus();
//         printWindow.print();
//         // Optional: close after printing
//         setTimeout(() => printWindow.close(), 500);
//       };
//     } catch (err) {
//       // 4️⃣ Fallback → Download PDF
//       pdf.save(`LoanSlip_${data.customerName || "Customer"}.pdf`);
//     }
//   };

//   if (!data) {
//     return <div className="p-10 text-center">Receipt Data Not Found</div>;
//   }

//   return (
//     <div className="receipt-viewer-container">
//       {/* Action Buttons */}
//       <div className="receipt-actions receipt-no-print">
//         <button onClick={() => navigate(-1)} className="receipt-back-btn">
//           Back
//         </button>
//         <button onClick={handlePrint} className="btn-print-receipt">
//           Print Receipt
//         </button>
//         <button onClick={()=>{
//             handlePrintThermalSlip() 
//         }
//         }className="btn-thermal-print-receipt">
//           Thermal Print Receipt
//         </button>
//       </div>

//       {/* Printable Receipt Design */}
//       <div className="receipt-paper" ref={receiptRef}>
//         <div className="receipt-header-section">
//           <div className="receipt-header-company-section">
//             <div className="receipt-company-details">
//               <img src={company?.logoUrl} alt="logo" className="receipt-logo" />
//               <div className="receipt-header-company-info">
//                 <h1>{company?.name || "N/A"}</h1>
//                 <p className="address">
//                   <b>Address: </b>
//                   {company?.address || "N/A"}
//                 </p>
//                 <p className="contact">
//                   <b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b>{" "}
//                   {company?.email || "N/A"}
//                 </p>
//                 <p className="cin">
//                   <b>CIN:</b> {company?.cin || "N/A"}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="receipt-title-box">
//             <h2>COLLECTION RECEIPT</h2>
//             <p>
//               Receipt No: #{data.id || "905"} | Date:{" "}
//               {new Date(Date.now()).toLocaleDateString(
//                 "en-GB",
//               )||data.createdAt }
//             </p>
//           </div>
//         </div>

//         {/* Sections */}
//         <div className="receipt-section">
//           <h3 className="receipt-section-title">Collection DETAILS</h3>
//           <div className="receipt-details-wrapper">
//             <div className="receipt-grid-item">
//               <span>Customer Name:</span> <strong>{data.customerName || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Loan Account Number:</span>{" "}
//               <strong>{data.loanNumber || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Emi Number:</span>{" "}
//               <strong>{data.emiNumber || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Emi Amount:</span>{" "}
//               <strong>{"₹"+data.emiAmount || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Principal Amount:</span>{" "}
//               <strong>{"₹"+data.principalComponent || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Interest Rate:</span>{" "}
//               <strong>{"₹"+data.interestComponent || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Due Date:</span>{" "}
//               <strong>
//                 {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Paid Date:</span>{" "}
//               <strong>
//                 {new Date(data.paymentDate).toLocaleDateString("en-GB") ||
//                   "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Status:</span>{" "}
//               <strong>{data.status.toUpperCase() || "N/A"}</strong>
//             </div>
//           </div>
//         </div>

//         <table className="receipt-outstanding-table">
//           <tr className="receipt-outstanding-row">
//             <td>Outstanding Amount</td>
//             <td>
//               ₹{" "}
//               {Number(data.outstanding).toLocaleString("en-IN", {
//                 minimumFractionDigits: 2,
//               })}
//             </td>
//           </tr>
//         </table>


//         <div className="receipt-footer-signs">
//           <div className="receipt-sign-box">
//             <div className="receipt-sign-line"></div>
//             <p>Authorized Signatory</p>
//           </div>
//           <div className="receipt-sign-box">
//             <div className="receipt-sign-line"></div>
//             <p>Customer Signature</p>
//           </div>
//         </div>

//         <p className="receipt-system-gen-text">
//           This is a system-generated slip and does not require a signature.
//           <br />
//           For any queries, please contact us during business hours.
//         </p>
//       </div>

      

// {/* Thermal print design */}
//       <div className="thermal-slip-wrapper">
//   <div ref={thermalReceiptRef} className="thermal-slip">
    
//     {/* COMPANY INFO */}
//     <div className="thermal-company">
//       <div className="thermal-company-name">
//         {company ? company.name : "--"}
//       </div>
//       <div className="thermal-company-text">
//         <b>Address:</b> {company ? company.address : "--"}
//       </div>
//       <div className="thermal-company-text">
//         <b>Phone:</b> {company ? company.contact : "--"} | <b>Email:</b> {company ? company.email : "--"}
//       </div>
//       <div className="thermal-company-text">
//         <b>CIN:</b> {company ? company.cin : "--"}
//       </div>
      
//     </div>

//     {/* TITLE */}
//     <div className="thermal-title">
//       Collection Receipt
//     </div>

//     <div className="thermal-divider"></div>

//     {/* DETAILS */}
//     <div className="thermal-row">
//       <b>Customer Name:</b> {data?.customerName || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Loan Account Number:</b> {data?.loanNumber || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>EMI Number:</b> {data?.emiNumber || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>EMI Amount:</b> {"₹"+data?.emiAmount || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Principal:</b>{"₹"+data?.principalComponent || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Interest Rate:</b> {"₹"+data?.interestComponent || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Due Date:</b> {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
//     </div>
//     <div className="thermal-row">
//       <b>Paid Date:</b> {new Date(data.paymentDate).toLocaleDateString("en-GB") ||
//                   "N/A"}
//     </div>
//     <div className="thermal-row">
//       <b>Status:</b> {data?.status || "--"}
//     </div>
//     <div className="thermal-row">
//       <b>Outstanding Amount:</b> ₹{" "}{data?.outstanding || "--"}
//     </div>

//     <div className="thermal-divider"></div>

//     {/* FOOTER */}
//     <div className="thermal-footer">
//       <div>Thank you for your payment!</div>
//       <div>
//        Computer Generated Receipt
//       </div>
//     </div>
//   </div>
// </div>
//     </div>
//   );
// };

// export default ViewLoanCollectionReceipt;





/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../assets/Loan/ViewLoanCollectionReceipt.css"; 
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const ViewLoanCollectionReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const singleReceipt = location.state?.collectionReceipt;
  const bulkReceipts = location.state?.receipts;

  const receiptList = React.useMemo(() => {
    if (Array.isArray(bulkReceipts) && bulkReceipts.length > 0) {
      return bulkReceipts;
    }
    if (singleReceipt && typeof singleReceipt === "object") {
      return [singleReceipt];
    }
    return [];
  }, [bulkReceipts, singleReceipt]);

  const receiptRef = useRef(null);
  const thermalReceiptRef = useRef(null);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  // fetch profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
        }
        if (data.qrCodeImage) {
          data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error("Error fetching company:", err);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchCompany();
    }
  }, [profile?.superAdminId]);

  const handlePrint = async () => {
    if (!receiptList.length) return;

    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < receiptList.length; i++) {
      const container = document.getElementById(`receipt-${i}`);
      if (!container) continue;

      if (i > 0) pdf.addPage();

      const canvas = await html2canvas(container, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#fff",
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.9);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
    }

    const blobUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      window.addEventListener("focus", () => {
        setTimeout(() => { if (document.body.contains(iframe)) document.body.removeChild(iframe); }, 500);
      }, { once: true });
    };
  };

  const handlePrintThermalSlip = async () => {
    if (!receiptList || receiptList.length === 0) return;

    try {
      const html2canvas = (await import("html2canvas")).default;
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <style>
              @page { size: 58mm auto; margin: 0; }
              body { margin: 0; padding: 0; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; }
              img { width: 58mm; max-width: 58mm; margin: 0 auto; display: block; }
              .page-break { page-break-after: always; height: 2mm; }
            </style>
          </head>
          <body></body>
        </html>
      `);
      doc.close();

      for (let i = 0; i < receiptList.length; i++) {
        const ref = document.getElementById(`thermal-${i}`);
        if (!ref) continue;

        const canvas = await html2canvas(ref, {
          scale: 3,
          backgroundColor: "#fff",
          useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const img = doc.createElement("img");
        img.src = imgData;

        await new Promise((res) => (img.onload = res));
        doc.body.appendChild(img);

        if (i !== receiptList.length - 1) {
          const divider = doc.createElement("div");
          divider.className = "page-break";
          doc.body.appendChild(divider);
        }
      }

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => { document.body.removeChild(iframe); }, 1000);
      }, 300);

    } catch (err) {
      console.error("Thermal printing failed", err);
      alert("Thermal print failed");
    }
  };

  const [company, setCompany] = useState(null);

  if (!receiptList.length) {
    return <div className="p-10 text-center">Receipt Data Not Found</div>;
  }

  return (
    <div className="receipt-viewer-container">
      {/* Action Buttons */}
      <div className="receipt-actions receipt-no-print">
        <button onClick={() => navigate(-1)} className="receipt-back-btn">Back</button>
        <button onClick={handlePrint} className="btn-print-receipt">Print Receipt</button>
        <button onClick={handlePrintThermalSlip} className="btn-thermal-print-receipt">Thermal Print Receipt</button>
      </div>

      {/* Printable A4 Receipt Design */}
      {receiptList.map((data, index) => {
        // --- प्रत्येक रसीद रिकॉर्ड के लिए अलग से गणना लॉजिक ---
        const isPartial = data?.status?.toLowerCase() === "partial";
        
        // भुगतान फ़ील्ड्स (payment1 से payment5) का इतिहास एरे बनाना
        const partialPaymentsHistory = [];
        let calculatedTotalPaid = 0;

        for (let i = 1; i <= 5; i++) {
          const amount = data[`payment${i}`];
          const date = data[`payment${i}Date`];
          const mode = data[`payment${i}Mode`];
          if (amount !== null && amount !== undefined && amount > 0) {
            partialPaymentsHistory.push({ index: i, amount, date, mode });
            calculatedTotalPaid += Number(amount);
          }
        }

        // कुल जमा राशि
        const totalPaidTillDate = data?.paidAmount || data?.partiallyPaidAmount || calculatedTotalPaid || data?.lastPaidAmount || data?.emiAmount || 0;
        
        // पेनल्टी राशि निर्धारण
        const penaltyAmount = Number(data?.penaltyAmount === 0 ? (data?.penalty || 0) : (data?.penaltyAmount || 0));
        const totalPayable = (data?.emiAmount || 0) + penaltyAmount;
        
        // रसीद दिनांक
        const receiptDate = data?.paymentDate || data?.lastPaidDate || data?.updatedAt || data?.createdAt || new Date().toISOString();

        return (
          <div
            key={data.id || index}
            id={`receipt-${index}`}
            style={{ pageBreakAfter: "always" }}
            className="receipt-paper"
            ref={receiptRef}
          >
            <div className="receipt-header-section">
              <div className="receipt-header-company-section">
                <div className="receipt-company-details">
                  {company?.logoUrl && <img src={company.logoUrl} alt="logo" className="receipt-logo" />}
                  <div className="receipt-header-company-info">
                    <h1>{company?.name || "TechVision Finance"}</h1>
                    <p className="address"><b>Address: </b>{company?.address || "N/A"}</p>
                    <p className="contact"><b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b> {company?.email || "N/A"}</p>
                    <p className="cin"><b>CIN:</b> {company?.cin || "N/A"}</p>
                  </div>
                </div>
              </div>

              <div className="receipt-title-box">
                <h2>COLLECTION RECEIPT</h2>
                <span className={`status-badge-top ${data?.status?.toLowerCase()}`}>
                  {data?.status?.toUpperCase()}
                </span>
                <p>
                  Receipt No: #{data.id || "N/A"} | Date: {new Date(receiptDate).toLocaleDateString("en-GB")}
                </p>
              </div>
            </div>

            {/* Loan Details */}
            <div className="receipt-section">
              <h3 className="receipt-section-title">LOAN & CUSTOMER DETAILS</h3>
              <div className="receipt-details-wrapper text-dark-design">
                <div className="receipt-grid-item">
                  <span>Customer Name:</span> <strong>{data.customerName || data?.loan?.userName || "N/A"}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>Loan Account Number:</span> <strong>{data.loanNumber || data?.loan?.loanAccountNumber || "N/A"}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>EMI Number:</span> <strong>{data.emiNumber || "N/A"}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>Due Date:</span> <strong>{data.dueDate ? new Date(data.dueDate).toLocaleDateString("en-IN") : "N/A"}</strong>
                </div>
              </div>
            </div>

            {/* Financial Breakdown */}
            <div className="receipt-section">
              <h3 className="receipt-section-title">FINANCIAL SUMMARY</h3>
              <div className="receipt-details-wrapper payment-summary-box">
                <div className="receipt-grid-item">
                  <span>Standard EMI Amount:</span> <strong>₹{(data.emiAmount || 0).toLocaleString('en-IN')}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>Penalty Charges:</span> <strong className="text-danger">₹{penaltyAmount.toLocaleString('en-IN')}</strong>
                </div>
                <div className="receipt-grid-item total-payable-row">
                  <span>Total Payable for this EMI:</span> <strong>₹{totalPayable.toLocaleString('en-IN')}</strong>
                </div>
                {/* <div className="receipt-grid-item total-paid-highlight">
                  <span>Total Paid Till Date:</span> <strong className="text-success">₹{totalPaidTillDate.toLocaleString('en-IN')}</strong>
                </div> */}

                {isPartial && (
                  <div className="receipt-grid-item balance-highlight">
                    <span>Remaining EMI Balance:</span> <strong className="text-warning">₹{(data?.emiBalance || 0).toLocaleString('en-IN')}</strong>
                  </div>
                )}

                <div className="receipt-grid-item">
                  <span>Principal Component:</span> <strong>₹{(data.principalComponent || 0).toLocaleString('en-IN')}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>Interest Component:</span> <strong>₹{(data.interestComponent || 0).toLocaleString('en-IN')}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>Transaction Date:</span> <strong>{data.paymentDate ? new Date(data.paymentDate).toLocaleDateString("en-IN") : new Date(receiptDate).toLocaleDateString("en-IN")}</strong>
                </div>
                <div className="receipt-grid-item">
                  <span>Payment Mode:</span> <strong>{data?.payment1Mode || "Cash"}</strong>
                </div>
              </div>
            </div>

            {/* Dynamic Partial Breakdown Table */}
            {partialPaymentsHistory.length > 0 && (
              <div className="receipt-section">
                <h3 className="receipt-section-title">PAYMENT BREAKDOWN (TRANSACTION HISTORY)</h3>
                <table className="receipt-breakdown-table">
                  <thead>
                    <tr>
                      <th>Trx No.</th>
                      <th>Payment Date</th>
                      <th>Payment Mode</th>
                      <th style={{ textAlign: "right" }}>Amount Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partialPaymentsHistory.map((pay) => (
                      <tr key={pay.index}>
                        <td>#{pay.index}</td>
                        <td>{pay.date ? new Date(pay.date).toLocaleDateString("en-IN") : "--"}</td>
                        <td><span className="mode-tag">{pay.mode || data?.payment1Mode || "Cash"}</span></td>
                        <td style={{ textAlign: "right" }}><strong>₹{pay.amount.toLocaleString('en-IN')}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* <table className="receipt-outstanding-table">
              <tbody>
                <tr className="receipt-outstanding-row">
                  <td>Remaining Outstanding Principal</td>
                  <td>
                    ₹ {Number(data.outstanding || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
              </tbody>
            </table> */}

            <div className="receipt-footer-signs" style={{ marginTop: "30px" }}>
              <div className="receipt-sign-box">
                <div className="receipt-sign-line"></div>
                <p>Authorized Signatory</p>
              </div>
              <div className="receipt-sign-box">
                <div className="receipt-sign-line"></div>
                <p>Customer Signature</p>
              </div>
            </div>

            <p className="receipt-system-gen-text">
              This is a system-generated slip and does not require a physical signature.
              <br />
              For any queries, please contact us during business hours.
            </p>
          </div>
        );
      })}

      {/* Thermal Print Slip Design Wrapper */}
      {receiptList.map((data, index) => {
        const isPartial = data?.status?.toLowerCase() === "partial";
        
        const partialPaymentsHistory = [];
        let calculatedTotalPaid = 0;
        for (let i = 1; i <= 5; i++) {
          const amount = data[`payment${i}`];
          if (amount !== null && amount !== undefined && amount > 0) {
            partialPaymentsHistory.push({ index: i, amount, date: data[`payment${i}Date`], mode: data[`payment${i}Mode`] });
            calculatedTotalPaid += Number(amount);
          }
        }

        const totalPaidTillDate = data?.paidAmount || data?.partiallyPaidAmount || calculatedTotalPaid || data?.lastPaidAmount || data?.emiAmount || 0;
        const penaltyAmount = Number(data?.penaltyAmount === 0 ? (data?.penalty || 0) : (data?.penaltyAmount || 0));
        const receiptDate = data?.paymentDate || data?.lastPaidDate || data?.updatedAt || data?.createdAt || new Date().toISOString();

        return (
          <div
            key={`thermal-wrapper-${index}`}
            id={`thermal-${index}`}
            className="thermal-slip-wrapper"
          >
            <div ref={thermalReceiptRef} className="thermal-slip">
              <div className="thermal-company">
                <div className="thermal-company-name">{company ? company.name : "--"}</div>
                <div className="thermal-company-text"><b>Address:</b> {company ? company.address : "--"}</div>
                <div className="thermal-company-text"><b>Phone:</b> {company ? company.contact : "--"}</div>
              </div>

              <div className="thermal-divider"></div>
              <div className="thermal-title">EMI COLLECTION SLIP</div>
              <div className="thermal-row"><b>Status:</b> {data?.status?.toUpperCase()}</div>
              <div className="thermal-divider"></div>

              <div className="thermal-row"><b>Customer Name:</b> {data?.customerName || "--"}</div>
              <div className="thermal-row"><b>Account No:</b> {data?.loanNumber || "--"}</div>
              <div className="thermal-row"><b>EMI Number:</b> {data?.emiNumber || "--"}</div>
              
              <div className="thermal-divider"></div>
              <div className="thermal-row"><b>EMI Amt:</b> ₹{data?.emiAmount || "0"}</div>
              <div className="thermal-row"><b>Penalty:</b> ₹{penaltyAmount || "0"}</div>
              {/* <div className="thermal-row font-large"><b>Total Paid:</b> ₹{totalPaidTillDate}</div> */}
              
              {isPartial && <div className="thermal-row text-danger"><b>EMI Balance:</b> ₹{data?.emiBalance || "0"}</div>}
              
              {/* Thermal Breakdown History */}
              {partialPaymentsHistory.length > 0 && (
                <>
                  <div className="thermal-divider"></div>
                  <div style={{ fontSize: "11px", fontWeight: "bold", textAlign: "center" }}>PAYMENT HISTORY</div>
                  {partialPaymentsHistory.map((p) => (
                    <div className="thermal-row" style={{ fontSize: "10px" }} key={p.index}>
                      <span>Txn#{p.index} ({p.mode || "Cash"}):</span>
                      <strong>₹{p.amount}</strong>
                    </div>
                  ))}
                </>
              )}

              <div className="thermal-divider"></div>
              {/* <div className="thermal-row"><b>Outstanding:</b> ₹{data?.outstanding || "0"}</div> */}
              <div className="thermal-row"><b>Due Date:</b> {data.dueDate ? new Date(data.dueDate).toLocaleDateString("en-GB") : "N/A"}</div>
              <div className="thermal-row"><b>Payment Date:</b> {new Date(receiptDate).toLocaleDateString("en-GB")}</div>

              <div className="thermal-divider"></div>
              <div className="thermal-footer">
                <div>Thank you for your payment!</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ViewLoanCollectionReceipt;